import React from 'react';
import "./Modal.css"

import {
    Modal,
} from 'react-bootstrap';

import AdminServicePlan from '../../../services/ob-core/admin-service-plan'
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class ModalActiveServicePlan extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            reason: '',
        };
    }

    block = () => {
        let payload = {
            id: this.props.data.id,
        };
        AdminServicePlan.active(payload, res => {
            if (res.errorCode === "One-Book-User.E000017") {
                toast.success(res.message[0]);
            } else if (res.success) {
                toast.success('Kích hoạt gói dịch vụ thành công !');
                this.props.onHide();
                this.props.onRefresh()
            } else {
                toast.success('Có lỗi xảy ra !');
            }
        })
    }


    render() {
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>

                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>THÔNG BÁO</b></h1>
                        </div>

                        <div className='d-flex justify-content-center mt-3 mb-3'>
                            <label className='font-size-content'>Bạn có chắc chắn kích hoạt gói dịch vụ này không ?</label>
                        </div>


                        <div className=" align-right col-12">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2">
                                <button
                                    type="button"
                                    className="ml-4 col-3 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                    onClick={() => this.block()}
                                >
                                        <span className='d-flex justify-content-center'>
                                            Đồng ý
                                        </span>
                                </button>
                                <button
                                    type="button"
                                    className="ml-4 col-3 border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className='d-flex justify-content-center'>
                                            Hủy bỏ
                                        </span>
                                </button>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}


export  default  ModalActiveServicePlan
